(() => {
'use strict';
const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
function queryFromPrompt(raw) {
 let q = window.KMSearchLanguage ? window.KMSearchLanguage.normalize(raw) : raw.trim(), max = null;
 const price = q.match(/\b(?:under|below|within|up to|budget(?: of)?)\s*(?:rs\.?|inr|₹)?\s*([\d,]+)/i);
 if (price) { max = Number(price[1].replaceAll(',','')); q = q.replace(price[0], ' '); }
 q = q.replace(/\b(?:i (?:want|need|am looking for)|looking for|please find|show me|buy me)\b/gi,' ').replace(/^\s*(?:a|an|the)\s+/i,'').trim();
 return {query:q || raw.trim(),max};
}
function init(scope) {
 scope.querySelectorAll('[data-smart-finder]').forEach(form => {
  if(form.dataset.ready) return; form.dataset.ready='true';
  form.addEventListener('submit',async event => {
   event.preventDefault();
   const status=form.querySelector('[data-finder-status]'), button=form.querySelector('button[type="submit"]');
   const raw=form.elements.q.value.trim(); if(!raw)return;
   const parsed=queryFromPrompt(raw), url=new URL(form.action,location.origin);
   url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');url.searchParams.set('q',parsed.query);
   const ageSelect=form.querySelector('[data-finder-age]'), age=ageSelect?.value, ageParam=ageSelect?.selectedOptions[0]?.dataset.param;
   const budget=(form.elements['filter.v.price.lte']?.value || '');
   if(age && /^filter\.[pv]\./.test(ageParam || ''))url.searchParams.set(ageParam,age);
   if(budget!==''||parsed.max!==null)url.searchParams.set('filter.v.price.lte',budget!==''?budget:String(parsed.max));
   const proxy=form.dataset.proxy;
   if(proxy && /^\/apps\/[a-zA-Z0-9_/-]+$/.test(proxy)) {
    button.disabled=true;status.textContent='Finding relevant search terms…';
    try {
     const response=await fetch(proxy,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query:raw,age:age||null,maxPrice:budget||parsed.max,currency:document.documentElement.dataset.currency}),signal:AbortSignal.timeout(7000)});
     if(!response.ok)throw new Error('Finder unavailable');
     const data=await response.json();
     if(typeof data.query==='string' && data.query.trim() && data.query.length<=200)url.searchParams.set('q',data.query.trim());
    } catch { status.textContent='Opening catalog search…'; }
   }
   location.assign(url.href);
  });
 });
 scope.querySelectorAll('[data-ranked-url]').forEach(root=>{
  if(root.dataset.loaded || !root.dataset.rankedUrl || root.dataset.rankedSort==='manual')return;
  root.dataset.loaded='true';
  const url=new URL(root.dataset.rankedUrl,location.origin);url.searchParams.set('sort_by',root.dataset.rankedSort);url.searchParams.set('section_id','km-ranked-products');
  const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
  fetch(url.href,{signal:AbortSignal.timeout(8000)}).then(r=>{if(!r.ok)throw new Error();return r.text();}).then(html=>{
   const result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-ranked-result]');
   if(result){const cards=Array.from(result.children).slice(0,Number(root.dataset.rankedCount)||10);root.replaceChildren(...cards);if(!cards.length){const message=document.createElement('p');message.className='km-age-empty';message.textContent='No products are currently listed in this collection.';root.append(message);}document.dispatchEvent(new Event('km:products-loaded'));}
  }).catch(()=>{}); // Keep server-rendered collection cards on network failure.
 });
 scope.querySelectorAll('[data-youtube-id]').forEach(button=>{
  if(button.dataset.ready)return;button.dataset.ready='true';
  button.addEventListener('click',()=>{
   const id=button.dataset.youtubeId;if(!/^[\w-]{11}$/.test(id))return;
   const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';iframe.title=button.getAttribute('aria-label');iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';button.replaceWith(iframe);
  });
 });
 scope.querySelectorAll('.km-watch .carousel-btn[data-scroll]').forEach(button=>{if(!scope.matches?.('.shopify-section') || button.dataset.kmNav)return;button.dataset.kmNav='1';button.addEventListener('click',()=>{const track=document.getElementById(button.dataset.scroll);if(track)track.scrollBy({left:(track.firstElementChild?.getBoundingClientRect().width||300)*Number(button.dataset.dir),behavior:motion.matches?'instant':'smooth'});});});

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
